@import "../../conversational-search-partials/feedback/feedback";
@import "../../conversational-search-partials/input-error-message/input-error-message.scss";
@import "../../../../../styles/variables";

.conversational-search-chat-widget-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  uiaas-search-widget-conversational-search-messages-mediators-wrapper {
    width: 100%;
  }

  &-elements {
    display: flex;
    flex: 1;
    justify-content: center;
    padding-top: 20px;
    position: relative;
    overflow: auto;
    overflow-x: hidden;

    @media (max-width: 1100px) {
      display: unset;
    }
  }

  &-control {
    background-color: $svs-ultra-light-grey-2;
    border-top: 1px solid $svs-super-light-grey;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    margin-top: 18px;
    padding: 16px 0 20px;
    position: relative;

    @media (max-width: 1024px) {
      padding: 16px 16px 14px;
    }

    @media (max-width: $uiaas-tablet) {
      background-color: unset;
      border-top: unset;
      padding-top: 0;
    }

    &-wrapper {
      max-width: 900px;
      width: 100%;

      & > :nth-child(2)::after {
        content: "";
        position: relative;
      }

      uiaas-search-conversational-search-tooltip-reactivity-wrapper {
        bottom: 135px;
        position: absolute;
        width: 233px;
      }

      &-actions {
        align-items: center;
        display: flex;

        qds-button {
          @media (max-width: $uiaas-tablet) {
            margin: 0;
          }
        }

        qds-input {
          width: 100%;
        }

        &-container {
          width: 100%;
          margin-right: 16px;
        }
      }
    }
  }
}

.tooltip-links {
  color: #0075a3;
  text-decoration: underline;
}

.outro-tooltip {
  float: left;
}

.conversational-search-feedback {
  @media (max-width: $uiaas-tablet) {
    width: calc(100% - 62px);
  }
}
